import O1HD from "../../../engines/gameEngine";
import utilsView from "../../../engines/libs/utilsView";
import { FileKind } from "../../define/FileKind";
import { BUNDLE_SMALL_NAME, getOneBundleOnePrefab } from "../BundleResourceConfig";
import { getBackGiveMap, getbackUseMap } from "../config/backpackConfig";
import { backpackGiveRuleI, backpackOpenType, backpackSaveData, backpackUpdataDialog, backpackUseRuleI, backUseOrGiveType } from "../config/backpackConst";
import backpackOpenBase from "../prefab/backpackOpenBase";
import clamShellOpen from "../prefab/clamShellGame/clamShellOpen";
import { NormalBackpackI, NormalBackpackType } from "./DefineInterface";
import NormalGameManager from "./NormalGameManager";

export default class backpackManager {

    gameManager:NormalGameManager = null;

    constructor(normalGameManager:NormalGameManager){
        this.gameManager = normalGameManager;
        this.loadManager();
    }

    private _backpack_save_data_key:string = "backpack-data-save-key";

    // 用于初始化
    private _initData:backpackSaveData = {
        useObjs: {},
        giveObjs: {}
    }

    //游戏数据
    private _data:backpackSaveData = {
        useObjs: {},
        giveObjs: {}
    }

    loadManager(){
        this.loadData();
    }

    loadData(){
        let d = O1HD.getServices().localStorageSrv.getStorage(this._backpack_save_data_key);
        if(!d || d == ""){
            this._data = <backpackSaveData>{};
        }else{
            this._data = JSON.parse(d);
        }
        for(let k in this._initData){
            if(this._data[k] == null){
                if(this._initData[k] instanceof Array){
                    this._data[k] = [].concat(this._initData[k]);
                }else{
                    this._data[k] = this._initData[k];
                }
            }
        }
        this.writeData();
    }

    writeData(){
        O1HD.getServices().localStorageSrv.setStorage(this._backpack_save_data_key,JSON.stringify(this._data));
    }

    getData(){
        return this._data;
    }

    resetData(){
        this._data = JSON.parse(JSON.stringify(this._initData));
        this.writeData();
    }

    resetManager(){
        this.resetData();
    }

    private checkUseRuleIsVaild(useItem:NormalBackpackI){
        let useRule:backpackUseRuleI = getbackUseMap()[useItem.id];
        if(!useRule){
            console.log(`未查到任何有关${useItem.name}物品的使用规则，请检查配置表`);
            return null;
        }
        let isOnly:boolean = useRule.isOnly;
        if(isOnly){
            let ariseRules = this.getData().useObjs;
            if(ariseRules[useRule.backId]){
                console.log("重复使用唯一的物品");
                return null;
            }
        }
        return useRule;
    }

    async checkVaildUseOrGiveRule(
        useItem:NormalBackpackI
        , npcName?:string
        , successFun: (item:NormalBackpackI)=>void = null
        , failFun:(item:NormalBackpackI)=>void = null
        , tNode: cc.Node = null
    ) {
        let useOrGiveRule:backpackUseRuleI | backpackGiveRuleI = null;
        if(npcName!=null){
            useOrGiveRule = this.checkGiveRuleIsVaild(useItem,npcName);
        }else{
            useOrGiveRule = this.checkUseRuleIsVaild(useItem);
        }
        // if(!this.checkUseRuleIsVaild(useItem)){
        //     return;
        // }
        let selectGoodsCount = 1;
        if(useOrGiveRule){
            let ruleType = useOrGiveRule.backUseOrGiveType;
            let param = useOrGiveRule.backUseOrGiveParam;
            switch(ruleType){
                case backUseOrGiveType.addCoin:{
                    this.backUseOrGiveType_addCoin(param["coin"]);
                    this.gameManager.onOutGoods(useItem.id,1);
                    break;
                }
                case backUseOrGiveType.openEvent:{
                    this.backUseOrGiveType_openEvent(param["openEvent"]);
                    this.gameManager.onOutGoods(useItem.id,1);
                    break;
                }
                case backUseOrGiveType.chatLink:{
                    this.backUseOrGiveType_chatLink(param["weChatLink"]);
                    this.gameManager.onOutGoods(useItem.id,1);
                    break;
                }
                case backUseOrGiveType.sell:{
                    let goodsData = this.gameManager.getOneGood(useItem.id);
                    
                    if (goodsData && goodsData.num > 1) {
                        await new Promise<void> ((resolve)=> {
                            utilsView.openPopupLayerTwo(
                                FileKind.PrefabFilePath.PacksackSellLayer
                                , null
                                , {
                                    goodsId: useItem.id
                                    , confirm: (selectNum: number)=> {
                                        selectGoodsCount = selectNum;
                                        resolve();
                                    }
                                    , cancel: ()=> {
                                        selectGoodsCount = 0;
                                        resolve();
                                    }
                                }
                            );
                        })
                        if (selectGoodsCount <= 0) {
                            return;
                        }
                    } 
                    this.gameManager.onOutGoods(useItem.id, selectGoodsCount);
                    O1HD.getServices().userSrv.setCoins(useItem.sellPrice * selectGoodsCount, true, tNode);
                    if(useItem.type && useItem.type.includes(NormalBackpackType.PWAN_OBJ)){
                        //如果是典当铺的物品则需要从典当铺中删除对应的物品
                        NormalGameManager._instance.pawnShopManager.spliceOneObj(NormalGameManager._instance.pawnShopManager.getLessObj(useItem.id.toString()));
                    }
                }
                break;
                case backUseOrGiveType.resolvePawnShopObj:
                case backUseOrGiveType.openOnePrefab:{
                    this.backUseOrGiveType_openOnePrefab(param["bundleName"],param["prefabUrl"],useOrGiveRule);
                    break;
                }
                case backUseOrGiveType.openNewLayer: {
                    utilsView.openPopupLayer(
                        param["prefabUrl"]
                        , param["bundleName"]
                        , null
                        , {
                            useOrGiveRule: useOrGiveRule
                        }
                    )
                }
                break;
                case backUseOrGiveType.lieYing :{
                    NormalGameManager._instance.onPushGoods(50022,1);
                    this.gameManager.onOutGoods(useItem.id,1);
                    break;
                }
                case backUseOrGiveType.upgradeOfficer:{
                    NormalGameManager._instance.addExp(param["exp"]);
                    this.gameManager.onOutGoods(useItem.id,1);
                    break;
                }
            }
            if(npcName!=null){
                let giveObj = this.getData().giveObjs[useItem.id];
                if(!giveObj){
                    this.getData().giveObjs[useItem.id] = [];
                }
                let itemId:number = useItem.id;
                let item = this.getData().giveObjs[useItem.id].find(value=>{
                    return value.backId == itemId && npcName == value.npcName;
                });
                if(item){
                    item.giveCount ++;
                }else{
                    item = {
                        backId:itemId,
                        npcName:npcName,
                        giveCount :1
                    }
                    this.getData().giveObjs[useItem.id].push(item);
                }
                this.writeData();
            }else{
                let useObj = this.getData().useObjs[useItem.id];
                if(useObj == null){
                    this.getData().useObjs[useItem.id] = selectGoodsCount;
                }else{
                    this.getData().useObjs[useItem.id] += selectGoodsCount;
                }
                this.writeData();
            }
            successFun && successFun(useItem);
        }else{
            // this.gameManager.onOutGoods(useItem.id,1);
            // O1HD.emit(backpackUpdataDialog);
            failFun && failFun(useItem);
        }
        if(npcName){
            O1HD.getModules().uiControlModule.showMessageBox("赠送成功!!");
        }
        // else{
        //     O1HD.getModules().uiControlModule.showMessageBox("使用成功!!");
        // }
    }

    outOneGood(id:number){
        this.gameManager.onOutGoods(id,1);
        O1HD.emit(backpackUpdataDialog);
    }

    private checkGiveRuleIsVaild(giveItem:NormalBackpackI,npcName:string){
        let id = giveItem.id;
        let ruleAry = getBackGiveMap()[id];
        if(ruleAry){
            let ariseAry = this.getData().giveObjs[id];
            if(!ariseAry){
                return ruleAry[0];
            }
            for(let i =0;i<ruleAry.length;i++){
                let ariseRule = ariseAry.find(value=>{
                    return value.npcName == npcName;
                });
                if(ariseRule && ruleAry[i].isOnly){
                    console.log("重复赠送唯一的物品");
                    return null;
                }
            }
            return ruleAry[0];
        }else{
            console.log(`未查到任何有关${giveItem.id}npc:${npcName}的赠送规则，请检查配置表`);
            return null;
        }

    }

    //加钱
    backUseOrGiveType_addCoin(coinNum:number){
        if(isNaN(coinNum)){
            coinNum = 0;
        }
        O1HD.getServices().userSrv.setCoins(coinNum,true,O1HD.Canvas());
    }

    //开启某个事件
    backUseOrGiveType_openEvent(eventId:string){
        NormalGameManager._instance.addOneEvent(eventId);
    }

    //开启某个聊天剧情
    backUseOrGiveType_chatLink(linkId:string){
        NormalGameManager._instance.addOneWeChatTriggerLinkUnShift(linkId);
    }

    //打开某个预制体
    async backUseOrGiveType_openOnePrefab(bundleName:BUNDLE_SMALL_NAME,url:string,useRule:backpackUseRuleI){
        let prefab = await getOneBundleOnePrefab(bundleName,url);
        console.log( "bundleName" , bundleName );
        if(prefab){
            let node:cc.Node = cc.instantiate(prefab);
            let nBase = node.getComponent(backpackOpenBase);
            if(nBase){
                nBase.onBackPackOpenPrefab(useRule);
                node.setParent(O1HD.Canvas());
            }else{
                console.error("打开了未实现onBackPackOpenPrefab的预制体" , url );
            }
        }else{
            console.error(`背包打开${bundleName}${url}预制体出错`);
            O1HD.getModules().uiControlModule.showMessageBox("加载失败~请重启游戏或者换台设备试试");
        }
    }

    //分解一个典当皮物品
    resolveOnePawnShopObj(useRule:backpackUseRuleI){
        let objId = useRule.backId;
        NormalGameManager._instance.pawnShopManager.resolveLessObj(objId.toString());
    }
}
